import { Box, Typography } from '@mui/material'
import { IconRosetteDiscountCheckFilled } from '@tabler/icons-react'
import React from 'react'
import PlainModal from '../../../../components/modal/PlainModal'
import useAppUtilities from '../../../../hooks/useAppUtilities'

interface ReservationSuccessfulDialogProps {
  open: boolean
  handleClose: () => void
  actionButton: () => void
  actionBUttonText: string
  subTitle: string
  title: string
  time: string
}

const ReservationSuccessfulDialog: React.FC<
  ReservationSuccessfulDialogProps
> = ({
  handleClose,
  open,
  actionButton,
  actionBUttonText,
  subTitle,
  title,
  time,
}) => {
  const { theme } = useAppUtilities()
  return (
    <PlainModal
      open={open}
      handleClose={handleClose}
      actionButtonName={actionBUttonText}
      onAction={actionButton}
    >
      <Box
        component="img"
        src="/images/leaderboard/coin-received.gif"
        alt="Background animation"
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '60%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
          opacity: 0.4,
        }}
      />
      <Box sx={{ position: 'relative', zIndex: 1, textAlign: 'center', px: 2 }}>
        <IconRosetteDiscountCheckFilled
          style={{ marginBottom: '16px', marginTop: '8px' }}
          size={50}
          color={theme.palette.success[500]}
        />
        <Typography variant="h4" mb={1}>
          {title}
        </Typography>
        <Typography variant="subtitle1">{subTitle}</Typography>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',

            mt: 2,
            mb: 4,
          }}
        >
          <Typography
            variant="body2"
            color="white"
            sx={{
              borderRadius: '15px',
              bgcolor: 'error.main',
              px: 1,
            }}
          >
            {time}
          </Typography>
        </Box>
      </Box>
    </PlainModal>
  )
}

export default ReservationSuccessfulDialog
